export default {
  entityName: 'user_survey'
}
